import MetabaseAnalyticsCard from "components/Templates/MetabaseAnalyticsCard"
import React from "react"

const DMCAnalyticsPage = () => {
  return (
    <div className="p-3">
      <MetabaseAnalyticsCard filter={{ dashboard: 19 }} />
    </div>
  )
}

export default DMCAnalyticsPage
